import React from 'react';
import { getOne, deleteOne } from 'api/facilitypermitApi';
import Message from 'rc-message';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import moment from 'moment';
import Permissions from 'react-redux-permissions';

// import * as _ from 'lodash';
import DisplayField from 'components/elements/display-field';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import slug from 'constants/slug';
import { COLOR, DATETIME_FORMAT, DATE_FORMAT } from 'config';
import AttachmentContainer from 'containers/AttachmentContainer';
import {
  getList as getFacAttachList,
  deleteOne as deleteAttach,
  create as createFacAttach,
} from 'api/permitattachmentApi';
import { getLookupTypePermitAttachment } from 'api/lookuplistitemApi';
import PageLockHOC from 'hoc/pageLock';
import { IS_ENTERPRISE } from 'config';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

@PageLockHOC(['facilityPermit.view'])
@connect(
  (state) => ({
    menuSelected_2: state.menu.menuSelected_2,
    focusFacility: state.menu.focusFacility,
  }),
  {}
)
class FacilitypermitView extends React.Component {
  state = {
    _idObject: '',
    isLoaded: false,
    isLoading: false,
    facility: {},
    facilityId: '',
    initialValue: null,
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    // return _.result(this.state.initialValue, keyPath, defaultValue);
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) {
      return '';
    }
    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  getInitialDateValue = (keyPath, isDate, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    if (isDate) return moment(value).format(DATE_FORMAT);
    return moment(value).format(DATETIME_FORMAT);
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOne(_id);
      // console.log(res);
      if (res.success && res.data) {
        this.setState({
          _idObject: res.data._id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoading: false,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.FACILITY_PERMIT.LIST);
    }
  }

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const LicenseNumber = this.getInitialValue('LicenseNumber.value');
      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xoá số giấy phép: `} <b> {LicenseNumber}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              if (this.props.menuSelected_2) {
                this.props.history.push(
                  `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                );
              } else {
                this.props.history.push(slug.FACILITY_PERMIT.LIST);
              }
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Chi tiết giấy phép
        </h4>
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            {/* <Link to={slug.FACILITY_PERMIT.LIST}> */}
            <Icon
              onClick={() => {
                if (this.props.menuSelected_2) {
                  this.props.history.push(
                    `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                  );
                } else {
                  this.props.history.push(slug.FACILITY_PERMIT.LIST);
                }
              }}
              style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
              icon={IconNames.CIRCLE_ARROW_LEFT}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
            />
            {/* </Link> */}
            {this.props.focusFacility && (
              <React.Fragment>
                <Permissions allowed={[`facilityPermit.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={
                        slug.FACILITY_PERMIT.EDIT_WITH_ID + this.state._idObject
                      }
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>
                <Permissions allowed={[`facilityPermit.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </React.Fragment>
            )}
          </div>
        </HeaderContainer>
        <Clearfix height={16} />
        <DisplayField
          isRequiredField
          label='Tên cơ sở/dự án'
          value={this.getInitialValue('facility.FacilityNameFull')}
        />
        {/* organizationName */}
        <Clearfix height={16} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <DisplayField
              label='Tên doanh nghiệp'
              value={this.getInitialValue('facility.organizationName')}
            />
            <Clearfix height={16} />
          </React.Fragment>
        )}
        <DisplayField
          isRequiredField
          label='Loại giấy phép'
          value={this.getInitialValue('permitType.Name')}
        />
        <Clearfix height={16} />
        <DisplayField
          isRequiredField
          label='Số giấy phép'
          value={this.getInitialValue('LicenseNumber.value')}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Tên giấy phép'
          value={this.getInitialValue('LicenseName')}
        />
        <Clearfix height={16} />
        <DisplayField
          isRequiredField
          label='Ngày cấp'
          value={this.getInitialDateValue('IssueDate', true)}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Ngày hết hạn'
          value={this.getInitialDateValue('ExpiryDate', true)}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Thời hạn giấy phép (năm)'
          value={this.getInitialValue('LicenseExpiry')}
        />
        <Clearfix height={16} />

        {!IS_ENTERPRISE && (
          <React.Fragment>
            <DisplayField
              label='Lưu lượng xả thải (m³/ngày.đêm)'
              value={this.getInitialValue('DischargeFlow')}
            />
            <Clearfix height={16} />
            <DisplayField
              label='Quy chuẩn'
              value={this.getInitialValue('Standard')}
            />
            <Clearfix height={16} />
          </React.Fragment>
        )}
        <DisplayField
          label='Ghi chú'
          value={this.getInitialValue('Notes', '')}
        />
        <Clearfix height={16} />
        <DisplayField
          label='Thêm vào'
          value={
            this.getInitialDateValue('AddedOn') +
            ' bởi ' +
            this.getInitialValue('AddedBy')
          }
        />
        <Clearfix height={16} />
        <DisplayField
          label='Cập nhật lần cuối'
          value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${
            this.getInitialValue('UpdatedBy', '')
              ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
              : ''
          }`}
        />

        <Clearfix height={8} />
        {this.state.isLoaded && (
          <AttachmentContainer
            hideButtonAction={this.props.focusFacility ? false : true}
            facility={this.state.initialValue}
            getListFunc={(query) => {
              return getFacAttachList({
                ...query,
                facilitypermit: this.state._idObject,
              });
            }}
            createOne={(values) => {
              values.facilitypermit = this.state._idObject;
              return createFacAttach(_.pickBy(values, _.identity));
            }}
            deleteOne={deleteAttach}
            getAttachmentTypeList={getLookupTypePermitAttachment}
            moduleName='facilityPermit'
          />
        )}
      </div>
    );
  }
}

export default withRouter(FacilitypermitView);



// WEBPACK FOOTER //
// ./src/containers/FacilitypermitContainer/FacilitypermitView/index.js